document.addEventListener('DOMContentLoaded', function () {
  const swiperContainers = document.querySelectorAll('.slider-custom-swiper');

  if (typeof Swiper === 'undefined') {
    console.error('Swiper is not loaded. Please include the Swiper JS library.');
    return;
  }

  swiperContainers.forEach((swiperContainer, index) => {
    const slidesOnDesktop = parseInt(swiperContainer.dataset.slidesOnDesktop) || 4;
    const slidesOnMobile = parseInt(swiperContainer.dataset.slidesOnMobile) || 1;
    const autoplayEnabled = swiperContainer.dataset.autoplay === 'true';
    const paginationStyle = swiperContainer.dataset.paginationStyle || 'bullets';

    try {
      // Initialize the Swiper instance for each container
      new Swiper(swiperContainer, {
        slidesPerView: slidesOnDesktop,
        loop: true,
        autoplay: autoplayEnabled
          ? {
              delay: 3000,
              disableOnInteraction: false,
            }
          : false,
        pagination: {
          el: swiperContainer.querySelector('.swiper-pagination'),
          clickable: true,
          type: paginationStyle,
        },
        navigation: {
          nextEl: swiperContainer.querySelector('.swiper-button-next'),
          prevEl: swiperContainer.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          0: {
            slidesPerView: slidesOnMobile,
          },
          768: {
            slidesPerView: slidesOnDesktop,
          },
        },
      });

      console.info(`Swiper instance ${index + 1} initialized successfully with configuration:`, {
        slidesOnDesktop,
        slidesOnMobile,
        autoplayEnabled,
        paginationStyle,
      });
    } catch (error) {
      console.error(`Error initializing Swiper instance ${index + 1}:`, error);
    }
  });
});
